import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import FeaturesSection from './components/FeaturesSection';
import RecommendSection from './components/RecommendSection';
import PartnershipSection from './components/PartnershipSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <ServiceSection />
      <FeaturesSection />
      <RecommendSection />
      <PartnershipSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}